import { TProductFiltersByNames } from '@cannect/services/resources/products'
import { ProductFiltersUI } from './ProductFiltersUI'
import { useProductFilters } from './useProductFilters'

export const ProductFilters = ({
  filters,
  onFiltersVisibilityChange,
  isFiltersVisible,
  hideToggleButton,
  showOnlyButton
}: {
  filters: TProductFiltersByNames
  onFiltersVisibilityChange?: (isVisible: boolean) => void
  isFiltersVisible?: boolean
  hideToggleButton?: boolean
  showOnlyButton?: boolean
}) => {
  const productFilters = useProductFilters()

  return (
    <ProductFiltersUI
      {...productFilters}
      filters={filters}
      onFiltersVisibilityChange={onFiltersVisibilityChange}
      isFiltersVisible={isFiltersVisible}
      hideToggleButton={hideToggleButton}
      showOnlyButton={showOnlyButton}
    />
  )
}

export { useProductFilters } from './useProductFilters'
export { ProductFiltersUI } from './ProductFiltersUI'
export { AppliedFiltersSection } from './AppliedFiltersSection'
export * from './types'
export * from './helpers'
